import { __awaiter, __generator, __read } from "tslib";
import { AppType } from '@office-start/app-gallery-types';
import { copilotM365AppId, getPlatformType, pinApp, useAppBarUserData, } from '@office-start/data-resolver-app-pinning';
import { useCallback, useEffect, useMemo } from 'react';
import { create } from 'zustand';
var usePinCopilotStore = create(function (set) { return ({
    isPinned: null,
    updateIsPinned: function (isPinned) { return set({ isPinned: isPinned }); },
}); });
/**
 * Custom hook to manage the state of pinning Copilot to the app bar.
 *
 * @returns A tuple containing:
 *   - The current state of whether Copilot is pinned to the app bar (boolean or null).
 *   - A function to pin Copilot to the app bar.
 */
export function usePinCopilotToAppBar() {
    var _this = this;
    var _a = usePinCopilotStore(), isPinned = _a.isPinned, updateIsPinned = _a.updateIsPinned;
    var _b = __read(useAppBarUserData(), 2), appBarUserData = _b[0], setAppBarUserData = _b[1];
    var isCopilotAppPinned = useMemo(function () {
        var _a;
        return ((_a = appBarUserData === null || appBarUserData === void 0 ? void 0 : appBarUserData.pinnedApps.some(function (state) { return state.id === copilotM365AppId; })) !== null && _a !== void 0 ? _a : null);
    }, [appBarUserData === null || appBarUserData === void 0 ? void 0 : appBarUserData.pinnedApps]);
    useEffect(function () {
        updateIsPinned(isCopilotAppPinned);
    }, [isCopilotAppPinned, updateIsPinned]);
    var pinCopilotToAppBar = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var platformType, newAppBarUserData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (appBarUserData === undefined) {
                        return [2 /*return*/];
                    }
                    platformType = getPlatformType(AppType.Mos);
                    newAppBarUserData = pinApp(appBarUserData, copilotM365AppId, platformType, 'UserPinned');
                    if (!(newAppBarUserData === appBarUserData)) return [3 /*break*/, 1];
                    // no change as the app was already pinned
                    return [2 /*return*/];
                case 1: return [4 /*yield*/, setAppBarUserData(newAppBarUserData)];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, [appBarUserData, setAppBarUserData]);
    return {
        isPinned: isPinned,
        pinCopilotToAppBar: pinCopilotToAppBar,
    };
}
//# sourceMappingURL=usePinCopilotToAppBar.js.map